module.exports = __webpack_public_path__ + "img/smartbarcode-logo.6b52a4df.jpg";